import store from "../store";
import { liff, config } from "../main";
export default async function auth({ next, from, to, redirect }) {
  try {
    if (!store.state.templateReady || !store.state.shortProfile.user_guid) {
      const res = await store.dispatch("getUserBind");

      if (res == 1) {
        if (
          config.line_layout == "Blank Theme" &&
          to.fullPath != "/blank-theme-landing" &&
          to.fullPath != "/privilege"
        )
          return next("/blank-theme-landing");
        return next();
      } else {
        console.log(to);
        return next({
          path: "/validatetelephone",
          query: {
            redirect: to.path,
            ...to.query
          }
        });
      }
    } else if (
      config.line_layout == "Blank Theme" &&
      to.fullPath != "/blank-theme-landing" &&
      to.fullPath != "/privilege"
    )
      return next("/blank-theme-landing");

    return next();
  } catch (error) {
    console.error(error);
    console.log(error);
  }
}
